module.exports = __webpack_public_path__ + "static/media/ic_01_userfriendly.85722ffc.svg";